// extracted by mini-css-extract-plugin
export default {"walletPendingItemContainer":"style_walletPendingItemContainer__aMKpK","result":"style_result__M+wGk"};